import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { fuseAnimations } from "@fuse/animations";
import { FuseTranslationLoaderService } from "@fuse/services/translation-loader.service";
import { Subscription } from "rxjs";
import { CotizacionDTO } from "../../shared/interfaces/cotizacion.interface";
import { ServicioCotizadoDTO } from "../../shared/interfaces/servicio-cotizado.interface";
import { CotizacionesService } from "../../shared/services/rest/cotizaciones.service";
import { DialogService } from "../../shared/services/rest/dialog.service";
import { NotificacionesService } from "../../shared/services/rest/notificaciones.service";
import { OrdenesDeTrabajoService } from "../../shared/services/rest/ordenes-de-trabajo.service";
import { DialogCotizarServicioComponent } from "./components/dialog-cotizar-servicio/dialog-cotizar-servicio.component";
import { DialogDetalleServicioComponent } from "./components/dialog-detalle-servicio/dialog-detalle-servicio.component";
import { DialogSolicitarServicioComponent } from "./components/dialog-solicitar-servicio/dialog-solicitar-servicio.component";
import { locale as english } from "./i18n/en";
import { locale as spanish } from "./i18n/es";
import { CotizacionServicioDTO } from "../../shared/models/cotizacion-servicio.model";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { finalize } from "rxjs/operators";
import { DialogRechazarServicioComponent } from "./components/dialog-rechazar-servicio/dialog-rechazar-servicio.component";
import { DialogContratistasComponent } from "./components/dialog-contratistas/dialog-contratistas.component";
import { DialogActualizarVigenciaComponent } from "../cotizaciones/components/dialog-actualizar-vigencia/dialog-actualizar-vigencia.component";
import { Moment } from "moment";
@Component({
    selector: "app-detalle-cotizacion",
    templateUrl: "./detalle-cotizacion.component.html",
    styleUrls: ["./detalle-cotizacion.component.scss"],
    animations: fuseAnimations,
})
export class DetalleCotizacionComponent implements OnInit, OnDestroy {
    servicios: ServicioCotizadoDTO[];
    cotizacion: CotizacionDTO;
    idCotizacion: number;
    subscripciones: Subscription;
    procesando:boolean=false;
    constructor(
        private _fuseTranslationLoaderService: FuseTranslationLoaderService,
        private _cotizacionSrvc: CotizacionesService,
        private _activatedRouteSrv: ActivatedRoute,
        private _notificacionSrvc: NotificacionesService,
        private _oottSrv: OrdenesDeTrabajoService,
        private _dialogSrvc: DialogService,
        private _fuseProgressBarService: FuseProgressBarService,
        private _router: Router
    ) {
        this.subscripciones = new Subscription();
        this._fuseTranslationLoaderService.loadTranslations(english, spanish);
    }

    ngOnInit(): void {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._activatedRouteSrv.params
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((params) => {
                    //console.log(params);
                    this.idCotizacion = params["idCotizacion"];
                    this.getServiciosCotizacion(this.idCotizacion);
                })
        );
    }

    getServiciosCotizacion(idCotizacion: number) {
        this._fuseProgressBarService.show();
        this.subscripciones.add(
            this._cotizacionSrvc
                .fetchServiciosCotizacion(idCotizacion)
                .pipe(finalize(() => this._fuseProgressBarService.hide()))
                .subscribe((cotizacion) => {
                    //console.log(cotizacion);
                    this.cotizacion = cotizacion;

                    this._cotizacionSrvc.onServicioCotizacionChanged$.next(
                        cotizacion
                    );
                    this.servicios = this.cotizacion.servicios;
                })
        );
    }

    openDialogSolicitarServicio(servicio: ServicioCotizadoDTO) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogSolicitarServicioComponent,
            "clase-dialog",
            "600px",
            servicio
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log("Dialog result:", result);
            if (result) {
                //console.log(result);
                //llamar a servicio que genera solicitud
                this._fuseProgressBarService.show();
                this.subscripciones.add(
                    this._oottSrv
                        .comprarServicio(
                            servicio.idCotizacionServicio,
                            result.ticket
                        )
                        .pipe(
                            finalize(() => this._fuseProgressBarService.hide())
                        )
                        .subscribe((resp) => {
                            this._notificacionSrvc.mostrarNotificacion(
                                "Servicio solicitado correctamente",
                                "success"
                            );
                            this._router.navigateByUrl("/cotizaciones");
                        })
                );
            }
        });
    }

    openDialogRechazarServicio(servicio: ServicioCotizadoDTO) {
        //console.log("rechazar");
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogRechazarServicioComponent,
            "clase-dialog",
            "600px",
            servicio
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log("Dialog result:", result);
            if (result) {
                this._fuseProgressBarService.show();
                //console.log("entro");
                this._cotizacionSrvc
                    .rechazarCotizacionServicio(
                        servicio.idCotizacionServicio,
                        result.observacion
                    )
                    .pipe(finalize(() => this._fuseProgressBarService.hide()))
                    .subscribe((resp) => {
                        this._notificacionSrvc.mostrarNotificacion(
                            "Servicio rechazado",
                            "success"
                        );
                        this.getServiciosCotizacion(this.idCotizacion);
                    });
            }
        });
    }

    openDialogDetalleServicio(servicio: ServicioCotizadoDTO) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogDetalleServicioComponent,
            "clase-dialog",
            "600px",
            servicio
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log("Dialog result:", result);
            if (result) {
                console.log("else");
            }
        });
    }

    cotizarServicio(servicioCotizado: ServicioCotizadoDTO) {
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogCotizarServicioComponent,
            "clase-dialog",
            "600px",
            servicioCotizado
        );

        dialogRef.afterClosed().subscribe((result) => {
            //console.log("Dialog result:", result);
            if (result) {
                //console.log(servicioCotizado);
                //console.log(result);
                //console.log(this.idCotizacion);
                const { descripcionTrabajo, valor, tiempoTrabajo } = result;
                const cotizacionServicio = new CotizacionServicioDTO(
                    servicioCotizado.idServicioSolicitudCotizacion,
                    descripcionTrabajo,
                    tiempoTrabajo,
                    valor
                );
                //console.log(cotizacionServicio);
                this._fuseProgressBarService.show();
                this.subscripciones.add(
                    this._cotizacionSrvc
                        .generaCotizacionServicio(cotizacionServicio)
                        .pipe(
                            finalize(() => this._fuseProgressBarService.hide())
                        )
                        .subscribe((resp) => {
                            this.getServiciosCotizacion(this.idCotizacion);
                            this._notificacionSrvc.mostrarNotificacion(
                                "Cotización de servicio ingresada",
                                "success"
                            );
                        })
                );
            }
        });
    }

    invitarACotizar(servicio: ServicioCotizadoDTO) {
        console.log(servicio);

        const { sucursal } = servicio;
        const { comuna } = sucursal;
        const dialogRef = this._dialogSrvc.abrirDialog(
            DialogContratistasComponent,
            "clase-dialog",
            "100%",
            {
                idServicioSolicitudCotizacion:
                    servicio.idServicioSolicitudCotizacion,
                idComuna: comuna.id,
                idRegion: comuna.region.id,
            }
        );
    }

 
    refrescarDatos(idCotizacion:number){
        this.getServiciosCotizacion(idCotizacion);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
